<template>
  <div class="p-base-info">
    <div class="infos">
      <div class="brand" @click="jump(`beastapp://brand/${product.brand.id}?title=${product.brand.name}`)">{{product.brand && product.brand.name}}</div>
      <div class="name">{{product.name}}</div>
      <div class="prices">
        <div class="mainStationFirst" v-if="product.mainStationFirst">首单价: </div>
        <div class="real" :class="{'firstColor':product.mainStationFirst}">
          <div class="price" :class="{rush: product._rush.state}">
            <price :data="product.format_price.price.min"></price>
          </div>
          <div 
            v-if="product.format_price.price.max && product.format_price.price.max >product.format_price.price.min" 
            class="price"
            :class="{rush: product._rush.state}"
          >
            - <price :data="product.format_price.price.max"></price>
          </div>
        </div>
        <div class="raw">
          <div class="rawPrice" v-if="product.format_price.price.min != product.format_price.rawPrice.min">
            <div class="price" v-if="product.format_price.rawPrice.min">
              <price :data="product.format_price.rawPrice.min"></price>
            </div>
            <div class="price" v-if="product.format_price.rawPrice.max && product.format_price.rawPrice.max > product.format_price.rawPrice.min">
              - <price :data="product.format_price.rawPrice.max"></price>
            </div>
          </div>
        </div>
      </div>
      <div class="newn-tag" v-if="isNewTag && !product.mainStationFirst">新人价</div>
      <div class="price-tag-wrap" v-if="product.spvPriceTag && product.spvPriceTag.length">
        <div class="price-tag" v-for="priceTag in product.spvPriceTag">
          <span class="price-tag-text" :style="{color:priceTag.textColor, borderColor: priceTag.edgeColor }">{{ priceTag.text }}</span>
        </div>
        <div class="price-tag-more">
          <span class="price-more" @click="showPriceTag">···</span>
        </div>
      </div>

      <div class="stocks-warn" v-if="product.spvStockWarn">{{product.spvStockWarn || ''}}</div>
      <div class="refunds" v-if="myFundPrice.length === 1" @click="goFunds">约返{{myFundPrice[0] | formatPrice}}元{{refundsName}}</div>
      <div class="refunds" v-else-if="myFundPrice.length && myFundPrice[0] == myFundPrice[myFundPrice.length - 1]" @click="goFunds">约返{{myFundPrice[0] | formatPrice}}元{{refundsName}}</div>
      <div class="refunds" v-else-if="myFundPrice.length > 0" @click="goFunds">约返{{myFundPrice[0] | formatPrice}} ~ {{this.fundPrice[myFundPrice.length-1] | formatPrice}}元{{refundsName}}</div>

      <div class="downpay-infos" v-if="product.downPayment">
        <div class="downpay-price-box">
          <div class="downpay-label">预付定金价：</div>
          <div class="downpay-price" v-if="product.downPayment.range[0] !== product.downPayment.range[1]">
            <price :data="product.downPayment.range[0]"></price>
              - <price :data="product.downPayment.range[1]"></price>
          </div>
          <div class="downpay-price" v-else>
            <price :data="product.downPayment.range[0]"></price>
          </div>
        </div>
        <div class="downpay-desc-box">
          <div class="downpay-desc">
            <div class="desc-box">
              <div class="desc-item" v-for="(item, index) in product.downPayment.details" :key="item.spvId">
                <span class="desc-label" v-if="index == 0">定金 </span>
                <span class="desc-price" v-if="index == 0">
                  <price :data="item.price"></price>
                </span>
                <span class="desc-price" v-else-if="!product.downPayment.priceSingle">
                  - <price :data="item.price"></price>
                </span>
              </div>
              <div class="desc-item" v-if="product.downPayment.deductionFlag" v-for="(item, index) in product.downPayment.details" :key="item.spvId">
                <span class="desc-label" v-if="index == 0">可抵 </span>
                <span class="desc-deduction" v-if="index == 0">
                  <price :data="item.deduction"></price>
                </span>
                <span class="desc-deduction" v-else-if="!product.downPayment.deductionSingle">
                  - <price :data="item.deduction"></price>
                </span>
              </div>
              <div class="desc-time">| {{product.downPayment.downTimeStr}}</div>
            </div>
            
            <div class="desc-box" :class="{'none': product.downPayment.tips?false:true}">
              <div class="desc-item" v-for="(item, index) in finalDetails" :key="index">
                <span class="desc-label" v-if="index == 0">尾款 </span>
                <span class="desc-price" v-if="index == 0">
                  <price :data="item"></price>
                </span>
                <span class="desc-price" v-else-if="!product.downPayment.finalSingle">
                  - <price :data="item"></price>
                </span>
              </div>
              <div class="desc-time">| {{product.downPayment.finalTimeStr}}</div>
            </div>

            <div class="desc-tips" v-if="product.downPayment.tips">
              <p class="desc-tip" v-for="(item, index) in product.downPayment.tips" :key="index"><span>*</span> {{ item }}</p>
            </div>
          </div>
          <div class="downpay-rule" @click="downpayRuleAction"></div>
        </div>

        <div class="downpay-image" v-if="product.waterMarkImage && product.waterMarkImage.length && product.waterMarkImage[0].indexOf('homegift.jpg')!==-1" @click="downpayImageAction">
          <img :src="product.waterMarkImage[0]" />
        </div>
      </div>
    </div>

    <div class="price-forecasts" v-if="product.priceForecast">
      <div class="forecast-details">
       <span class="forecast-details-name">{{ product.priceForecast.name }}</span>
       <span class="forecast-details-price">{{ product.priceForecast._price }}</span>
       <span class="forecast-details-date"><i> | </i> {{ product.priceForecast._since }} {{(product._rush.notAll && product._rush.state) ? '(商品部分规格不支持抢购)':''}}</span>
      </div>
    </div>
    <div class="presell" v-if="product.presell">
      {{product.presell && product.presell.content}} <template v-if="product._rush.notAll && product._rush.state"></template>
    </div>

    <div class="custom-card" v-if='product.customPrintTemplate == 6'>本商品享受<span>「刻字服务」</span>，请在下单时选择</div>
    <div class="custom-card" v-else-if='product.canCustomCard'>该商品支持定制<span>专属标签</span>，请在下单时选择</div>
    

    <div class="p-info-tip" v-if="product.furniture || (product.needVerifyAddress && !product.monthSend)">
      <div class="tips">
        <div class="tip" v-for="tip in product.tips">
          <div class="address-tip-title" v-if="tip.presentation">{{tip.presentation}}</div>
          <p v-if="tip.content">{{ tip.title }}<span class="content">{{ tip.content }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Price from '@/price/index'
import browser from '@beastshop/browser'
import bridge from '@beastshop/bridge'
import {
  getLink 
} from '@/components/app-menu/util'
import {
  transformLink,
  trackSkip
} from '@/link'

export default {
  props: ['product', 'fundPrice'],

  data () {
    return {
      downpayData: null,
      myFundPrice: this.fundPrice,
      refundsName: '',
      finalDetails: []
    }
  },

  components: {
    Price
  },

  created () {
    this.product.variant.spvs.forEach(spv => {
      if (!spv.refunds) return
      this.myFundPrice.push(spv.refunds)
      this.refundsName = spv.refundsName
    })
    this.myFundPrice = this.fundPrice.sort(this.sort)
    this.formatData()
  },

  watch: {
    fundPrice (price) {
      if (!this.fundPrice.length) {
        this.myFundPrice = []
      }
      else if (this.fundPrice.length === 1) {
        this.myFundPrice = [this.fundPrice[0]]
      }
      else if (this.fundPrice.length > 1 && (this.fundPrice[0] == this.fundPrice[this.fundPrice.length - 1])) {
        this.myFundPrice = [this.fundPrice[0]]
      }
      else {
        this.myFundPrice = [this.fundPrice[0], this.fundPrice[this.fundPrice.length - 1]]
      }
    },
  },

  computed: {
    isNewTag () {
      let newComer = false
      if (!this.product) return

      this.product.variant.spvs.forEach(spv => {
        if (spv.newcomerTag) {
          newComer = true
        }
      })

      return newComer
    }
  },

  methods: {
    formatData () {
      const downPayment = this.product.downPayment
      const details = downPayment && downPayment.details
      let finalDetails = []
      
      if (details) {
        details.forEach(d => {
          if(finalDetails.indexOf(d.finalPrice) === -1) {
            finalDetails.push(d.finalPrice)
          }
        })
      }
      
      // finalDetails = [10, 20, 9, 30]
      finalDetails.sort(function(a,b){return a>b?1:-1})
      
      if(finalDetails.length) {
        this.finalDetails = finalDetails.length>1?[finalDetails[0], finalDetails[finalDetails.length-1]]:finalDetails
        // this.finalDetails = finalDetails
      }
    },

    sort (a, b) {
      return a > b
    },
 
    tagPath: (name) => {
      return `https://img.thebeastshop.com/app/product/detail/${name}.png`
    },

    jump (link) {
      if(browser.app()) {
        bridge.open({
          url: link
        })
      } else {
        window.location.href = getLink(link)
      }

      // let _link = link
      // if (!browser.app()) {
      //   _link = getLink(link)
      // }

      // window.location.href = _link
    },

    downpayRuleAction () {
      if(browser.app()) {
        bridge.open({
          url: `beastapp://article/1033174`
        })
      } else {
        window.location.href = `/article?articleId=1033174`
      }
    },

    goFunds () {
      if (browser.app()) {
        bridge.open({
          url: `beastapp://article?articleId=1040184`
        })
      } else {
        window.location.href = '/article?articleId=1040184'
      }
    },

    getCounponAction (coupons) {
      this.$selectCoupon(coupons)
      .then(() => {

      })
      .catch(err => {
        
      })
    },

    showPriceTag () {
      this.$emit('showPriceTag', true)
    },

    downpayImageAction () {
      let myLink = this.product.waterMarkImage[1]
      if(myLink) {
        if(typeof myLink === 'string') {
          myLink = JSON.parse(myLink)
        }

        trackSkip({
          trackData: {
            name: 'product-downpay-image',
            wait: false
          },
          link: transformLink({
            link: myLink
          })
        })
      }
    }

  },

  filters: {
    formatPrice (value) {
      let v = String(Math.floor(value*Math.pow(10,1)) / Math.pow(10,1))
        const temp = v.split('.')
        return temp.length > 1 
          ? v
          : `${v}.0`
    }
  },
}
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// product-info.vue?74afb074